import { downloadPDF, getDomain } from "../../../Utilities/utils";
import Axios from "axios";
import Swal from "sweetalert2";
import { POLICY_DOWNLOAD_API_ENDPOINT } from "../../apiConfig";

export default function downloadPolicyHelper(
  setLoading,
  transferData,
  policyNumber,
  navigateToThankYouPage
) {
  setLoading(true);
  // Django domain
  const domain = getDomain();

  if (transferData?.product_name === "Reliance IPA") {
    // If policy number is not present, return
    if (!policyNumber) {
      setLoading(false);
      showErrorDialog();
      return;
    }
    Axios.get(
      `${domain}${POLICY_DOWNLOAD_API_ENDPOINT}/${policyNumber}/${transferData.A_id}`
    )
      .then((response) => {
        console.log("response: ", response);
        if (response.status === 200) {
          const fileName = `${transferData.product_name} ${policyNumber} .pdf`;
          downloadPDF(response.data.pdf_bytes, fileName);
          showSuccessDialog(navigateToThankYouPage);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log("Error in download policy", error);
        setLoading(false);
        showErrorDialog();
      });
  }
}

const showErrorDialog = () => {
  Swal.fire({
    icon: "error",
    title: "Failed to download policy",
    position: "center",
    showClass: {
      popup: "animate__animated animate__fadeInDown",
    },
    hideClass: {
      popup: "animate__animated animate__fadeOutUp",
    },
  });
};

const showSuccessDialog = (navigateToThankYouPage) => {
  Swal.fire({
    icon: "success",
    title: "Your Policy is Downloaded",
    position: "center",
    showClass: {
      popup: "animate__animated animate__fadeInDown",
    },
    hideClass: {
      popup: "animate__animated animate__fadeOutUp",
    },
  }).then((result) => {
    if (result.isConfirmed) {
      navigateToThankYouPage();
    }
  });
};
